// rcUnified.ts

/** ---------- Public types ---------- */
export type EntitlementId = string;
export type PackageId = string;
export type OfferingId = string;

export type PackageFrequency = 'monthly' | 'annual' | 'unknown';

// Unified wrapper around Package implementations
export interface PackageSummary {
    id: PackageId; // RC package identifier
    title: string;
    frequency: PackageFrequency;
    price: {
        amount: number; // 4.99
        currencyCode: string; // "USD"
        localized: string; // "$4.99"
    };
    _impl: any; // underlying RC package
}

export interface CustomerState {
    appUserId: string;
    entitlementsActive: Record<EntitlementId, boolean>;
    raw?: any; // RC CustomerInfo (debugging)
}

export interface RCAdapter {
    /** MUST be called with a real user id (no anonymous init). */
    getPackages(offeringId?: OfferingId): Promise<PackageSummary[]>;
    hasEntitlement(appUserId: string, id: EntitlementId, useCache: boolean): Promise<boolean>;
    purchase(appUserId: string, pkg: PackageSummary): Promise<CustomerState>;
    restore(appUserId: string): Promise<CustomerState>;
    getSubscriptionManagementUrl(appUserId: string): Promise<string | null>;
}

/** ---------- Shared helpers ---------- */
export function normalizeCustomer(info: any): CustomerState {
    const active = info?.entitlements?.active ?? {};
    const appUserId = info?.originalAppUserId ?? info?.appUserID ?? info?.appUserId ?? 'unknown';
    const map: Record<string, boolean> = {};
    for (const k of Object.keys(active)) map[k] = Boolean(active[k]);
    return { appUserId, entitlementsActive: map, raw: info };
}
